import {Component, inject} from '@angular/core';
import {Router} from "@angular/router";
import {PathEnum} from "../../../@application/enum/path.enum";

@Component({
    selector: 'app-system-settings',
    templateUrl: './system-settings.component.html',
    styleUrl: './system-settings.component.scss',
    standalone: false
})
export class SystemSettingsComponent {

  router = inject(Router)
  onInventoryManagement() {
    this.router.navigate([PathEnum.Home, PathEnum.Settings, PathEnum.InventoryManagement]);
  }

  onRestaurantManagement() {
    this.router.navigate([PathEnum.Home, PathEnum.Settings, PathEnum.RestaurantManagement]);
  }

  onUserManagement() {
    this.router.navigate([PathEnum.Home, PathEnum.Settings, PathEnum.UserManagement]);
  }

  onMenuManagement() {
    this.router.navigate([PathEnum.Home, PathEnum.Settings, PathEnum.MenuManagement]);
  }

  onSystemSettings(){
    this.router.navigate([PathEnum.Home, PathEnum.Settings, PathEnum.SystemSetting]);

  }
}
